import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';

const WaitingStatus = () => {
  const params = new URLSearchParams(window.location.search);
  const shopId = Number(params.get('shop_id') || 0);
  const waitingId = Number(params.get('waiting_id') || 0);
  const token = params.get('token') || '';

  const [loading, setLoading] = useState(true);
  const [shopName, setShopName] = useState('');
  const [data, setData] = useState(null);
  const [error, setError] = useState('');

  const wsRef = useRef(null);
  const refreshTimerRef = useRef(null);
  const renderSoonTimerRef = useRef(null);
  const reconnectRef = useRef(null);

  async function fetchStatus() {
    const url = `/api/waiting/status-api?shop_id=${encodeURIComponent(shopId)}&waiting_id=${encodeURIComponent(waitingId)}&token=${encodeURIComponent(token)}&_=${Date.now()}`;
    const res = await axios.get(url, {
      withCredentials: true,
      headers: { 'Cache-Control': 'no-store' },
    });
    return res.data;
  }

  function statusBadge(status) {
    const map = {
      WAITING: 'secondary',
      CALLED: 'warning',
      ENTERED: 'success',
      CANCELLED: 'dark',
      NO_SHOW: 'danger',
    };
    return map[status] || 'secondary';
  }

  async function renderStatus() {
    try {
      const j = await fetchStatus();

      if (!j.success) {
        setError(j.message || '조회 실패');
        setData(null);
        return;
      }

      setError('');
      setData(j.data);
    } catch (e) {
      console.error(e);
      setError('조회 실패');
      setData(null);
    }
  }

  function renderSoon() {
    if (renderSoonTimerRef.current) clearTimeout(renderSoonTimerRef.current);
    renderSoonTimerRef.current = setTimeout(() => {
      renderStatus();
    }, 80);
  }

  function scheduleRefresh() {
    if (refreshTimerRef.current) return;
    refreshTimerRef.current = setTimeout(() => {
      refreshTimerRef.current = null;
      renderSoon();
    }, 300);
  }

  async function cancelSelf() {
    if (!window.confirm('웨이팅을 취소할까요?')) return;

    const fd = new FormData();
    fd.append('mode', 'cancel_self');
    fd.append('shop_id', String(shopId));
    fd.append('waiting_id', String(waitingId));
    fd.append('token', token);

    try {
      const res = await axios.post('/api/seller/waiting/manage-api', fd, {
        withCredentials: true,
      });
      const j = res.data;
      alert(j.message || (j.success ? '취소 완료' : '취소 실패'));
      renderSoon();
    } catch (e) {
      console.error(e);
      alert('취소 실패');
    }
  }

  function connectWS() {
    const proto = window.location.protocol === 'https:' ? 'wss' : 'ws';
    const wsUrl = `${proto}://${window.location.host}/ws/?shop_id=${shopId}`;
    const ws = new WebSocket(wsUrl);
    wsRef.current = ws;

    ws.onopen = () => console.log('WS connected', wsUrl);
    ws.onclose = () => {
      reconnectRef.current = setTimeout(connectWS, 1500);
    };
    ws.onerror = () => ws.close();

    ws.onmessage = (e) => {
      try {
        const msg = JSON.parse(e.data);
        const msgShopId = Number(msg.shop_id);
        if (msg.type === 'waiting' && msgShopId === shopId) {
          scheduleRefresh();
        }
      } catch (err) {}
    };
  }

  useEffect(() => {
    const init = async () => {
      try {
        const res = await axios.get(
          `/api/waiting/status-init?shop_id=${encodeURIComponent(shopId)}&waiting_id=${encodeURIComponent(waitingId)}&token=${encodeURIComponent(token)}`,
          { withCredentials: true }
        );

        if (!res.data || res.data.ok !== true) {
          alert((res.data && res.data.message) || '파라미터 오류');
          return;
        }

        setShopName(res.data.shop_name || '알 수 없는 가게');
        await renderStatus();
        connectWS();
      } catch (e) {
        console.error(e);
        alert('초기화 실패');
      } finally {
        setLoading(false);
      }
    };

    init();

    return () => {
      if (refreshTimerRef.current) clearTimeout(refreshTimerRef.current);
      if (renderSoonTimerRef.current) clearTimeout(renderSoonTimerRef.current);
      if (reconnectRef.current) clearTimeout(reconnectRef.current);
      if (wsRef.current) wsRef.current.close();
    };
  }, []);

  if (loading) {
    return <div className="p-3">불러오는 중...</div>;
  }

  return (
    <>
      <style>{`
        :root{
          --brand:#0d6efd;
          --brand2:#0b5ed7;
          --bg:#ffffff;
          --muted:#8b8f9b;
          --line:#eceef5;
          --shadow:0 10px 24px rgba(16,24,40,.08);
          --radius:18px;
        }
        body{ background:var(--bg); }
        .appbar{
          height:56px;
          display:flex;
          align-items:center;
          justify-content:center;
          position:sticky;
          top:0;
          background:#fff;
          border-bottom:1px solid var(--line);
          z-index:10;
        }
        .appbar .back{
          position:absolute;
          left:14px;
          width:38px;height:38px;
          border-radius:12px;
          border:1px solid var(--line);
          background:#fff;
          display:flex;
          align-items:center;
          justify-content:center;
          font-weight:900;
          cursor:pointer;
          user-select:none;
        }
        .appbar .title{
          font-weight:900;
          letter-spacing:-0.2px;
        }
        .page{
          max-width:520px;
          margin:0 auto;
          padding:16px 16px 120px;
        }
        .shopname{
          font-weight:900;
          font-size:28px;
          letter-spacing:-0.6px;
          text-align:center;
          margin-top:8px;
        }
        .cardbox{
          background:#fff;
          border:1px solid var(--line);
          border-radius:var(--radius);
          box-shadow:var(--shadow);
          padding:18px;
        }
        .bottom-cta{
          position:fixed;
          left:0; right:0;
          bottom:0;
          padding:12px 16px calc(12px + env(safe-area-inset-bottom));
          background:rgba(255,255,255,.92);
          backdrop-filter: blur(10px);
          border-top:1px solid var(--line);
          z-index:20;
        }
        .bottom-cta .wrap{
          max-width:520px;
          margin:0 auto;
        }
        .btn-brand{
          height:56px;
          width:100%;
          border:none;
          border-radius:16px;
          background:var(--brand);
          color:#fff;
          font-weight:900;
          font-size:16px;
          letter-spacing:-0.2px;
        }
        .btn-brand:active{ transform: translateY(1px); }
        .btn-brand:hover{ background:var(--brand2); }
        .badge{ border-radius:999px; padding:.55em .8em; }
        .alert{ border-radius:16px; border:1px solid var(--line); }
        hr{ border-color:var(--line); opacity:1; }
        .text-muted{ color:var(--muted) !important; }
      `}</style>

      <div className="appbar">
        <div className="back" onClick={() => window.history.back()}>←</div>
        <div className="title">웨이팅 정보</div>
      </div>

      <main className="page">
        <div className="shopname">{shopName}</div>

        <div className="cardbox mt-3">
          {error ? (
            <div className="text-danger">{error}</div>
          ) : data ? (
            <>
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <div className="fs-5 fw-bold">번호 {data.waiting_number}</div>
                  <div className="text-muted">{data.name} · {data.people}명</div>
                </div>
                <div>
                  <span className={`badge text-bg-${statusBadge(data.status)}`}>{data.status}</span>
                </div>
              </div>

              <hr />

              <div>앞 팀 수: <b>{data.ahead_count}</b></div>
              <div>예상 대기: <b>{data.estimated_minutes ?? '-'}분</b></div>
              <div className="text-muted mt-2">등록시간: {data.created_at}</div>

              {data.status === 'CALLED' && (
                <div className="alert alert-warning mt-3 mb-0">지금 입장해주세요!</div>
              )}
              {data.status === 'ENTERED' && (
                <div className="alert alert-success mt-3 mb-0">입장 완료 처리되었습니다.</div>
              )}
              {(data.status === 'CANCELLED' || data.status === 'NO_SHOW') && (
                <div className="alert alert-secondary mt-3 mb-0">대기가 종료되었습니다.</div>
              )}
            </>
          ) : (
            <div>불러오는 중...</div>
          )}
        </div>
      </main>

      <div className="bottom-cta">
        <div className="wrap">
          <button
            id="cancelBtn"
            className="btn-brand"
            style={{ display: data && data.status === 'WAITING' ? 'block' : 'none' }}
            onClick={cancelSelf}
          >
            등록 취소하기
          </button>
        </div>
      </div>
    </>
  );
};

export default WaitingStatus;